export const FEEDBACK_DIALOG_COPY =
  "This tool is not intended to help determine if an expense is considered non-taxable. Consult with your own tax/legal advisor to determine whether an expense is non-taxable. Justworks does not provide tax or legal advice.";
